import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Trophy, Users, Calendar, Award } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';

const CompetitionsPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={100} />
      
      <div className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>
          
          <div className="mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Compétitions
            </h1>
            <p className="text-xl text-gray-600">
              Tournois et championnats du club
            </p>
          </div>

          {/* Hero Image */}
          <div className="mb-16 rounded-3xl overflow-hidden shadow-2xl">
            <img 
              src="https://images.unsplash.com/photo-1622279457486-62dcc4a431d6?w=1200&q=80"
              alt="Compétitions de tennis"
              className="w-full h-96 object-cover"
            />
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <Link 
              to="/interclubs"
              className="group bg-gradient-to-br from-green-50 to-emerald-50 p-10 rounded-2xl hover:shadow-xl transition-all"
            >
              <Users className="w-16 h-16 text-green-600 mb-4 group-hover:scale-110 transition-transform" />
              <h3 className="text-3xl font-bold text-gray-900 mb-3">Interclubs</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Championnat interclubs Swiss Tennis. Nos équipes participent régulièrement 
                aux championnats dans différentes catégories.
              </p>
              <div className="text-green-600 font-semibold group-hover:translate-x-2 transition-transform inline-block">
                En savoir plus →
              </div>
            </Link>

            <Link 
              to="/tournois"
              className="group bg-gradient-to-br from-blue-50 to-cyan-50 p-10 rounded-2xl hover:shadow-xl transition-all"
            >
              <Trophy className="w-16 h-16 text-blue-600 mb-4 group-hover:scale-110 transition-transform" />
              <h3 className="text-3xl font-bold text-gray-900 mb-3">Tournois</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Tournois internes pour tous les niveaux. Une occasion de progresser 
                et de se mesurer à d'autres joueurs dans une ambiance conviviale.
              </p>
              <div className="text-blue-600 font-semibold group-hover:translate-x-2 transition-transform inline-block">
                En savoir plus →
              </div>
            </Link>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-red-50 p-10 rounded-2xl mb-12">
            <Award className="w-12 h-12 text-orange-600 mb-4" />
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Participer aux compétitions</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Que vous soyez débutant ou joueur confirmé, il y a une compétition pour vous ! 
              Les interclubs et tournois sont ouverts à tous les membres du club.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Contactez-nous pour plus d'informations sur les prochaines compétitions 
              et pour vous inscrire à une équipe.
            </p>
          </div>

          <div className="bg-gray-900 text-white p-12 rounded-3xl">
            <h2 className="text-3xl font-bold mb-6">Rejoignez la compétition</h2>
            <p className="text-gray-300 mb-8 text-lg">
              Intéressé par les compétitions ? Contactez-nous pour rejoindre une équipe 
              ou participer aux prochains tournois.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/evenements"
                className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl font-semibold transition-all hover:scale-105"
              >
                Voir les événements
              </Link>
              <button 
                onClick={() => setIsContactModalOpen(true)}
                className="bg-white/10 hover:bg-white/20 text-white px-8 py-4 rounded-xl font-semibold transition-all hover:scale-105"
              >
                Nous contacter
              </button>
            </div>
          </div>
        </div>
      </div>

      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />

      <Footer />
    </div>
  );
};

export default CompetitionsPage;